import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { ValidateWorkShiftResponse, WorkShift } from '../interfaces/workshift';

@Injectable({
  providedIn: 'root',
})
export class WorkShiftService {
  private endpoint: string = environment.api;
  constructor(private httpClient: HttpClient) {}

  validateWorkShift(
    newWorkShift: WorkShift,
    workShifts: WorkShift[]
  ): Observable<ValidateWorkShiftResponse> {
    const url = '/commercial-agreements/validate-shift';

    const body = {
      new_shift: newWorkShift,
      shifts: workShifts,
    };

    return this.httpClient.post<ValidateWorkShiftResponse>(
      this.endpoint + url,
      body
    );
  }
}
